import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminClinicsPage } from './admin-clinics';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    AdminClinicsPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminClinicsPage),
    DirectivesModule
  ],
})
export class AdminClinicsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-clinics/admin-clinics.module.ts